import type { PostFormatDto, SavePostFormatRequestDto } from '@gr/core/content/posts/dto';

/** Значения формы правила оформления (POST-UC-10). */
export interface PostFormatValues {
  name: string;
  rules: string;
  isDefault: boolean;
}

export const POST_FORMAT_FIELDS = ['name', 'rules', 'isDefault'] as const;

export const NEW_POST_FORMAT: PostFormatValues = { name: '', rules: '', isDefault: false };

export function postFormatValuesOf(format: Pick<PostFormatDto, 'name' | 'rules' | 'isDefault'>): PostFormatValues {
  return { name: format.name, rules: format.rules, isDefault: format.isDefault };
}

export function saveRequestOf(values: PostFormatValues): SavePostFormatRequestDto {
  return { name: values.name.trim(), rules: values.rules, isDefault: values.isDefault };
}

/** POST-UC-11.CC-1: действующее правило поста — выбранное, иначе правило по умолчанию; null — правил нет. */
export function effectiveFormat(formatId: string | null, formats: readonly PostFormatDto[]): PostFormatDto | null {
  return (formatId ? formats.find((format) => format.id === formatId) : undefined) ?? formats.find((format) => format.isDefault) ?? null;
}

/**
 * Варианты выбора правила в посте: первым — «по умолчанию» (значение ''), с типом правила по
 * умолчанию в подписи, затем правила блога.
 */
export function formatOptions(formats: readonly PostFormatDto[], defaultLabel: (name: string | null) => string): { value: string; label: string }[] {
  const fallback = formats.find((format) => format.isDefault)?.name ?? null;
  return [{ value: '', label: defaultLabel(fallback) }, ...formats.map((format) => ({ value: format.id, label: format.name }))];
}
